import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ArrayHelpers, Loading, SystemText } from 'e4shared';
import { apiGet } from 'services';
import NoResults from 'components/general/noResults';
import { e4Format, e4Formats } from 'helpers/dates';

export const KnowledgeBankAnswers = ({ profileId, range, offset }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    React.useEffect(() => {
        const gotResponse = response => {
            setData(response);
            setLoading(false);
        };

        const qs = `?range=${range}&offset=${offset}`;
        profileId && apiGet(`answers/${profileId}${qs}`, guid, response => gotResponse(response));
    }, [guid, profileId, range, offset]);

    if (loading) return <Loading />;

    if (!ArrayHelpers.existsAndHasLength(data))
        return (
            <NoResults
                title={SystemText('User121/e4Metrics/Details/Answers/NoResults/Title')}
                message={SystemText('User121/e4Metrics/Details/Answers/NoResults/Message')}
            />
        );

    return (
        <div>
            {data.map(d => {
                return (
                    <div key={`answer-${d.id}`} className="mb10 flex">
                        <i className="fa fa-question-circle text-success" style={{ fontSize: '30px' }} />
                        <div className="ml20 flex-grow">
                            <div>
                                <b>{SystemText('User121/e4Metrics/Details/Answers/Question')}</b>
                                <br />
                                <Link data-testid="link-question" to={`/knowledge-bank/${d.question_Id}`}>
                                    {d.question}
                                </Link>
                            </div>
                            <div>
                                <b>{SystemText('User121/e4Metrics/Details/Answers/Answer')}</b>
                                <br />
                                {d.answer}
                            </div>
                            <div>
                                <b>{SystemText('User121/e4Metrics/Details/Answers/Answered')}</b>
                                <br />
                                {e4Format(d.created)}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default KnowledgeBankAnswers;
